import Vue from 'vue'
import Cookies from 'js-cookie'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'
import { translate } from '@/lang'

import '@/icons' // icon
import '@/permission' // permission control
import { base_file_url } from '@/utils/request'
import { Loading } from 'element-ui';

let loadingInstance;
//开启加载动画
Vue.prototype.startLoading = function(){
  loadingInstance = Loading.service(
    {lock: true,
    text: '加载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'});
}
//关闭加载动画
Vue.prototype.endLoading = function(){
  this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
    if (loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
  });
}
Vue.prototype.pageMinHeight = (document.body.clientHeight - 110) + "px"//自适应页面背景最小高度
Vue.prototype.$tApp = function(key) {
  return translate(store.getters.language, key)
}

function applyTheme(theme) {
  const body = document.body
  if (!body) return
  body.classList.remove('theme-light', 'theme-dark')
  body.classList.add(theme === 'dark' ? 'theme-dark' : 'theme-light')
}

function applyLanguage(language) {
  document.documentElement.setAttribute('lang', language === 'en' ? 'en' : 'zh-CN')
}

Vue.use(ElementUI, { 
  locale,
  size: Cookies.get('size') || 'medium', // set element-ui default size
 })
Vue.use(VCharts)

Vue.config.productionTip = false
Vue.prototype.BASE_FILE_URL = base_file_url //图片文件地址地址
applyTheme(store.getters.theme)
applyLanguage(store.getters.language)
store.subscribe((mutation, state) => {
  if (mutation.type === 'SET_THEME') {
    applyTheme(state.app.theme)
  }
  if (mutation.type === 'SET_LANGUAGE') {
    applyLanguage(state.app.language)
  }
})
// element ui 最初版本 2.3.7
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js